import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const TestimonialList = Loadable(
  lazy(() => import("features/testimonial/components/List"))
);
const TestimonialPage = Loadable(
  lazy(() => import("features/testimonial/components/Page"))
);

const routes = {
  path: "testimonial",
  children: [
    { path: "", element: <TestimonialList /> },
    { path: "add", element: <TestimonialPage /> },
    { path: "edit/:testimonialId?", element: <TestimonialPage /> },
  ],
};

export default routes;
